import React from 'react';
import { Icon, IconProps } from './Icon';

export const TrendingUpIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 22 12" strokeWidth={0.5} {...props}>
      <path
        d="M20.75 0C21.1593 0 21.4921 0.32795 21.5 0.735352V6C21.5 6.41421 21.1642 6.75 20.75 6.75C20.3407 6.75 20.0079 6.42205 20 6.01465V2.56055L14.0908 8.46973C13.6689 8.89161 13.0967 9.12891 12.5 9.12891C11.9126 9.12891 11.3486 8.89878 10.9287 8.48926L8.53027 6.09082C8.38963 5.95024 8.19886 5.87109 8 5.87109C7.80748 5.87109 7.62266 5.94579 7.4834 6.07812L7.46973 6.09082L1.78027 11.7803C1.48738 12.0732 1.01262 12.0732 0.719727 11.7803C0.430917 11.4915 0.427251 11.0262 0.708008 10.7324L0.719727 10.7197L6.40918 5.03027C6.83112 4.60839 7.40331 4.37109 8 4.37109C8.58735 4.37109 9.15141 4.60122 9.57129 5.01074L11.9697 7.40918C12.1104 7.54976 12.3011 7.62891 12.5 7.62891C12.6925 7.62891 12.8773 7.55421 13.0166 7.42188L13.0303 7.40918L18.9395 1.5H15.5C15.0907 1.5 14.7579 1.17205 14.75 0.764648V0.75C14.75 0.340718 15.078 0.0078637 15.4854 0H20.75Z"
        fill="#09865A"
      />
    </Icon>
  );
};
